"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const evaluateObjectOfEntryVars_1 = __importDefault(require("../../shared/evaluateObjectOfEntryVars"));
const valueIsNotUndefined_1 = __importDefault(require("../../typeAssertions/valueIsNotUndefined"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const valueIsAppProcessIdWithParams_1 = __importDefault(require("../../typeAssertions/valueIsAppProcessIdWithParams"));
const getErrorMessageNoProjectIdFoundInApp_1 = __importDefault(require("../getErrorMessageNoProjectIdFoundInApp"));
const buildCallableSendPush = (isDevelopment, generateCloudMessage) => async ({ controlCallerId, entryVars: { title, body, targetUserEmail, targetUserUid, targetAppId, sendToAll, androidVisibility, largeIconUrl, bigPictureUrl, usesChronometer, vibrate, }, processor, functionId, callbacks, executeProcesses, lastFunctionsOutputs, }) => {
    const executeError = (message) => {
        executeProcesses(functionId, callbacks.onError, message);
    };
    if (!(0, valueIsAppProcessIdWithParams_1.default)(targetAppId)) {
        executeError('Invalid targetAppId param');
        return;
    }
    if (targetUserEmail !== undefined && typeof targetUserEmail !== 'string') {
        executeError('Invalid target user email');
        return;
    }
    if (targetUserUid !== undefined && typeof targetUserUid !== 'string') {
        executeError('Invalid target user uid');
        return;
    }
    if (typeof title !== 'string') {
        executeError('Invalid notification title');
        return;
    }
    if (typeof body !== 'string') {
        executeError('Invalid notification body');
        return;
    }
    if (androidVisibility !== undefined && (typeof androidVisibility !== 'string'
        || (androidVisibility !== 'public' && androidVisibility !== 'private' && androidVisibility !== 'secret'))) {
        executeError('Invalid android visibility');
        return;
    }
    const evaluateEntryVar = processor.evaluateVarFactory({
        controlCallerId,
        lastFunctionsOutputs,
        itemContext: {},
    });
    const newAppProcessParams = await (0, evaluateObjectOfEntryVars_1.default)({
        evaluator: evaluateEntryVar,
        entryVarsObject: targetAppId.appProcessParams,
    });
    if ((0, valueIsNotUndefined_1.default)(largeIconUrl) && !(0, valueIsString_1.default)(largeIconUrl)) {
        executeError('Invalid android largeIconUrl');
        return;
    }
    if ((0, valueIsNotUndefined_1.default)(bigPictureUrl) && !(0, valueIsString_1.default)(bigPictureUrl)) {
        executeError('Invalid android bigPictureUrl');
        return;
    }
    const projectId = processor.root.getProjectId();
    if (!projectId) {
        executeError((0, getErrorMessageNoProjectIdFoundInApp_1.default)('sendPush'));
        return;
    }
    generateCloudMessage({
        projectId,
        appId: targetAppId.appId,
        targetUserEmail,
        targetUserUid,
        title,
        body,
        appProcessId: targetAppId.appProcessId,
        appProcessParams: newAppProcessParams,
        displayNotification: true,
        sendToAll: !!sendToAll,
        androidVisibility,
        largeIconUrl,
        bigPictureUrl,
        usesChronometer: !!usesChronometer,
        vibrate: !!vibrate,
    }).then((sendPushResult) => {
        if (sendPushResult.success === true) {
            if (sendPushResult.noTokensToSend && isDevelopment) {
                processor.root.alert('Warning', 'The target user doesn`t have tokens to send a push notification.');
                return;
            }
            executeProcesses(undefined, callbacks.onSuccess);
        }
        else {
            executeError(sendPushResult.message);
        }
    }).catch((error) => {
        executeError(error.toString());
    });
};
exports.default = buildCallableSendPush;
